export default {
  cityRuleDesc: '/clientEcosys/gold/cityRuleDesc'
}
